import { BFormGroup } from './form-group';
import { pluginFactory } from '../../utils/plugins';
var FormGroupPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BFormGroup: BFormGroup,
    BFormFieldset: BFormGroup
  }
});
export { FormGroupPlugin, BFormGroup };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-group/index.js
// module id = 471
// module chunks = 1